import Datepicker from 'flowbite-datepicker/Datepicker';
import { multipleSelect } from 'multiple-select-vanilla';

let multipleSelects = {};
let filterCategories = [];
const dateFilters = [];

$(document).ready(function () {
    document.querySelectorAll('.whats-on-filter-panel').forEach((filterPanel) => {
        const filterForm = filterPanel.querySelector('form');

        filterPanel.querySelectorAll('.date-filter').forEach((dateFilter) => {
            dateFilters.push(
                new Datepicker(dateFilter, {
                    autohide: true,
                    format: 'dd/mm/yyyy',
                    weekStart: 1
                })
            );

            dateFilter.addEventListener('changeDate', function(event) {
                onFilterChanged(event.target);
            });
        });

        filterPanel.querySelectorAll('select[data-filter-category]').forEach((filter) => {
            filter.addEventListener('change', function (event) {
                onFilterChanged(event.target);
            });

            const category = filter.getAttribute('data-filter-category');
            filterCategories.push(category);
            let msConfig = {
                selectAll: false,
                classes: 'form-control',
            };
            let ms = multipleSelect(`.multiple-select[data-filter-category="${category}"]`, msConfig);
            multipleSelects[category] = ms;

            // Something is setting the width to a large number. So we'll just clear it here.
            let parent = filter.closest('.multiselect')?.querySelector('.ms-parent');
            if (parent) {
                parent.style.width = '';
            }
        });

        filterPanel.querySelectorAll('input.events-filter[type="checkbox"]').forEach((filter) => {
            filter.addEventListener('change', function (event) {
                onFilterChanged(event.target);
            });
        });

        filterForm.addEventListener('reset', (event) => {
            for (const [category, multiSelect] of Object.entries(multipleSelects)) {
                multiSelect.uncheckAll();
            }

            // Using a timeout here as the actual fields only reset AFTER the event completes
            setTimeout(() => {
                onFilterChanged(filterForm);
            }, 10);
        });
    });

    initializeFilters();
});

const initializeFilters = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    for (let filterCategory of filterCategories) {
        let filterValues = urlParams.getAll(filterCategory);
        const selectElement = document.querySelector(`[data-filter-category="${filterCategory}"]`);
        const msElement = multipleSelects[filterCategory];
        if (selectElement && msElement) {
            msElement.setSelects(filterValues, 'text');
            onFilterChanged(selectElement);
        }
    }
    initializeCheckboxesFromUrl(urlParams, 'weblogic', '.discounts-filter', 'discount');
    initializeCheckboxesFromUrl(urlParams, 'tickets-available', '.tickets-available-filter', 'true');

    if (urlParams.has('date')) {
        const date = urlParams.get('date').split('-').reverse().join('-');
        for (let dateFilter of dateFilters) {
            dateFilter.setDate(date);
        }
    }
}

const initializeCheckboxesFromUrl = (urlParams, categoryCodeInUrl, filterClass, filterValueForChecked) => {
    const filterValues = urlParams.getAll(categoryCodeInUrl);
    if (filterValues.length > 0 && filterValues[0].length && filterValues[0].toLowerCase() === filterValueForChecked) {
        const filter = document.querySelector(`input${filterClass}[type="checkbox"]`);
        if (filter) {
            filter.checked = true;
            onFilterChanged(filter);
        }
    }
}

const parseEventTags = (eventTags) => {
    try {
        return JSON.parse(eventTags);
    } catch (e) {
        // Not json string, so just return the value
        return [eventTags];
    }
}

const onFilterChanged = (target) => {
    const eventsWrapper = target.closest('.whats-on-filter-panel');
    const dateFilter = eventsWrapper.querySelector('.date-filter').value;
    const ticketsAvailableFilter = eventsWrapper.querySelector('.tickets-available-filter').checked;
    const discountsFilter = eventsWrapper.querySelector('.discounts-filter').checked;

    let filters = {};
    const filterElements = eventsWrapper.querySelectorAll('select[data-filter-category]');
    filterElements?.forEach((filterElement) => {
        const categoryCode = filterElement.getAttribute('data-filter-category');
        filters[categoryCode] = multipleSelects[categoryCode]?.getSelects("text");
    });

    const noResultsContainer = eventsWrapper.closest('.whats-on-main-container').querySelector('.no-results-container');

    let shownCount = 0;
    eventsWrapper.nextElementSibling.querySelectorAll('.event-container').forEach((eventDiv) => {
        let match = true;

        if (dateFilter) {
            let performanceDate = new Date(eventDiv.getAttribute('data-date'));

            if (dateFilter) {
                let parts = dateFilter.split("/");
                let selectedDate = new Date([parts[2], parts[1], parts[0]].join("-"));
                match = performanceDate.getTime() === selectedDate.getTime();
            }
        }

        for (const [category, filterValues] of Object.entries(filters)) {
            if (match) {
                let eventTagValuesString = eventDiv.getAttribute(`data-${category}`);
                let eventTagValues = [];
                if (eventTagValuesString) {
                    eventTagValues = parseEventTags(eventTagValuesString?.toLowerCase());
                }
                let orMatch = false;
                if (filterValues && filterValues.length) {
                    for (let filterValue of filterValues) {
                        const lowerCaseFilterValue = filterValue?.toLowerCase().trim();
                        orMatch = orMatch || eventTagValues?.includes(lowerCaseFilterValue);
                    }
                    match = orMatch;
                }
            }
        }

        if (match && discountsFilter) {
            const discountTag = eventDiv.getAttribute('data-weblogic');
            match = (discountTag && discountTag.length) && discountTag?.toLowerCase()?.includes('discount');
        }

        if (match && ticketsAvailableFilter) {
            const ticketsAvailable = eventDiv.getAttribute('data-tickets-available');
            match = ticketsAvailable === '1';
        }

        if (match) {
            eventDiv.classList.remove('hidden');
            shownCount++;
        } else {
            eventDiv.classList.add('hidden');
        }
    });

    if (noResultsContainer) {
        if (shownCount > 0) {
            noResultsContainer.classList.add('hidden');
        }
        else {
            noResultsContainer.classList.remove('hidden');
        }
    }
};